export type AccountConfiguration = {
    affiliateName: string,
    companyCountry: string,
    companyCurrency: string,
    companyCurrencySymbol: string,
    companyIdentifier: string,
    companyLocale: string,
    companyName: string,
    companyStatus: string,
    companyCreationDate: string,
    helpUrl: string,
    id: string,
    upsellUrl: string,
    userId: string,
    userFirstname: string,
    userLastname: string,
    canTrackEvents: boolean,
    isCaBranchAffiliate: boolean,
    isCaiBranchAffiliate: boolean,
    isLclBranchAffiliate: boolean
};

export let configuration = {
    affiliateName: '',
    companyCountry: '',
    companyCurrency: '',
    companyCurrencySymbol: '$',
    companyIdentifier: '',
    companyLocale: '',
    companyName: '',
    companyStatus: '',
    companyCreationDate: '',
    helpUrl: '',
    id: '',
    upsellUrl: '',
    userId: '',
    userFirstname: '',
    userLastname: '',
    canTrackEvents: true,
    isCaBranchAffiliate: false,
    isCaiBranchAffiliate: false,
    isLclBranchAffiliate: false
} as AccountConfiguration;

export const loadConfiguration = () => {
    const configContainer = document.querySelector('#js-config');
    if (configContainer !== null) {
        configuration = {...configuration, ...JSON.parse(configContainer.textContent || '{}')};
    }
};